"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.__DEV__ = void 0;

/**
 * Current development environment
 * @type {boolean}
 */
var __DEV__ = process.env.NODE_ENV !== 'production';

exports.__DEV__ = __DEV__;